"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Helpers = void 0;
var _queryString = _interopRequireDefault(require("query-string"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// This regex is the simplified RFC 5322 expression from http://www.regular-expressions.info/email.html
var EMAIL_REGEX = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
var PATH_OVERRIDE = '/path-contained-email-address';
var Helpers = exports.Helpers = /*#__PURE__*/function () {
  function Helpers() {
    _classCallCheck(this, Helpers);
  }
  return _createClass(Helpers, null, [{
    key: "sendWrapperLoadError",
    value: function sendWrapperLoadError(message, data) {
      // TODO: Handle sending error somewhere, reference atl-analytics if needed
      console.warn("Error loading wrapper: ".concat(message), data);
    }
  }, {
    key: "getParameterByName",
    value: function getParameterByName(name) {
      //eslint-disable-next-line
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(window.location.search);
      var value = results && results.length >= 2 ? results[1] : null;
      return !value ? '' : decodeURIComponent(value.replace(/\+/g, ' '));
    }
  }, {
    key: "getUtms",
    value: function getUtms(utms) {
      if (window.location.search.includes('utm_')) {
        for (var utmKey in utms) {
          //eslint-disable-next-line
          if (utms.hasOwnProperty(utmKey)) {
            utms[utmKey] = Helpers.getParameterByName(utmKey);
          }
        }
        return utms;
      }
      return null;
    }

    // taken from https://github.com/segmentio/canonical/blob/master/lib/index.js
  }, {
    key: "canonical",
    value: function canonical() {
      var tags = Array.from(document.getElementsByTagName('link'));
      for (var _i = 0, _tags = tags; _i < _tags.length; _i++) {
        var tag = _tags[_i];
        if (tag && tag.getAttribute('rel') === 'canonical') {
          return tag.getAttribute('href');
        }
      }
      return null;
    }

    // taken from https://github.com/segmentio/analytics.js-core/blob/master/lib/pageDefaults.js
  }, {
    key: "getCanonicalUrl",
    value: function getCanonicalUrl() {
      var canon = Helpers.canonical();
      if (canon) {
        return canon;
      }
      var url = window.location.href;
      var i = url.indexOf('#');
      return i === -1 ? url : url.slice(0, i);
    }
  }, {
    key: "addActualUrl",
    value: function addActualUrl(obj) {
      if (window.location.href !== Helpers.getCanonicalUrl()) {
        // respect cleaned url
        if (obj['url']) {
          obj['actualUrl'] = obj['url'];
        } else {
          obj['actualUrl'] = Helpers.maskURL(window.location.href);
        }
      }
    }
  }, {
    key: "isObject",
    value: function isObject(o) {
      return o !== null && _typeof(o) === 'object' && Array.isArray(o) === false;
    }
  }, {
    key: "urlContainsEmail",
    value: function urlContainsEmail(url) {
      return Boolean(EMAIL_REGEX.exec(decodeURIComponent(url)));
    }

    // dropping attributes containing email
  }, {
    key: "dropEmailQueryParams",
    value: function dropEmailQueryParams(obj) {
      var sanitizedObj = {};
      Object.entries(obj).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (!Helpers.urlContainsEmail(value)) {
          sanitizedObj[key] = value;
        }
      });
      return sanitizedObj;
    }

    // mask search terms
  }, {
    key: "maskSearchTerms",
    value: function maskSearchTerms(obj) {
      var sanitizedObj = {};
      Object.entries(obj).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        if (key === 'term' || key === 'q') {
          sanitizedObj[key] = '[REDACTED]';
        } else {
          sanitizedObj[key] = value;
        }
      });
      return sanitizedObj;
    }

    // dropping email from the url path
  }, {
    key: "dropEmailFromPath",
    value: function dropEmailFromPath(path) {
      var newPath = '';
      if (Helpers.urlContainsEmail(path)) {
        var pathArray = path.split('/');
        pathArray.forEach(function (value) {
          if (value !== '' && !Helpers.urlContainsEmail(value)) {
            newPath = newPath + '/' + value;
          }
        });
      }
      return newPath === '' ? path : newPath;
    }

    // convert query params object to query params string
  }, {
    key: "convertQueryObjToString",
    value: function convertQueryObjToString(obj) {
      var queryString = new URLSearchParams(obj).toString();
      if (queryString !== '') {
        queryString = '?' + queryString;
      }
      return queryString;
    }
  }, {
    key: "emailAddressIsDetected",
    value: function emailAddressIsDetected() {
      return Helpers.urlContainsEmail(window.location.href) || Helpers.urlContainsEmail(document.referrer);
    }
  }, {
    key: "hostnameFromUrl",
    value: function hostnameFromUrl(url) {
      return url.replace(/http(s|):\/\//g, '').split(/(\/|:)/g)[0];
    }
  }, {
    key: "addCleanedUrlAndPaths",
    value: function addCleanedUrlAndPaths(obj) {
      obj['url'] = window.location.origin + PATH_OVERRIDE;
      obj['path'] = PATH_OVERRIDE;
      obj['search'] = '';
      return obj;
    }
  }, {
    key: "addCleanedReferrer",
    value: function addCleanedReferrer(obj) {
      obj['referrer'] = Helpers.urlWithoutPath(document.referrer) + PATH_OVERRIDE;
      return obj;
    }
  }, {
    key: "urlWithoutPath",
    value: function urlWithoutPath(url) {
      var fakeTag = document.createElement('a');
      fakeTag.href = url;
      return fakeTag.protocol + '//' + fakeTag.host;
    }

    /**
     * Urls containing email address in url path or query params are dropped and
     * search term query params are masked.
     * Search terms (and all UGC) should no longer be tracked.
     */
  }, {
    key: "maskURL",
    value: function maskURL(input) {
      if (input === '' || input === undefined) {
        return input;
      }
      var url = new URL(input);
      var obj = _queryString["default"].parse(url.search);
      obj = Helpers.dropEmailQueryParams(obj);
      if (url.pathname.includes('/search')) {
        obj = Helpers.maskSearchTerms(obj);
      }
      return url.origin + Helpers.dropEmailFromPath(url.pathname) + Helpers.convertQueryObjToString(obj);
    }
  }]);
}();